/** Two contiguous partitions of the same inlet. No minimum width invents use. */
export function waterfallFork(busyPercent: number, narrow = false) {
  const busy = Math.min(100, Math.max(0, Number.isFinite(busyPercent) ? busyPercent : 0));
  const totalWidth = narrow ? 48 : 88;
  const busyWidth = totalWidth * busy / 100;
  const idleWidth = totalWidth - busyWidth;
  const inletStart = narrow ? 151 : 102;
  const split = inletStart + (narrow ? idleWidth : busyWidth);
  const usedCenter = narrow ? split + busyWidth / 2 : inletStart + busyWidth / 2;
  const unusedCenter = narrow ? inletStart + idleWidth / 2 : split + idleWidth / 2;
  return {
    busyWidth, idleWidth, totalWidth, inletStart, split, usedCenter, unusedCenter,
    intake: narrow ? 'M175 61 V102' : 'M32 146 H232',
    used: narrow ? `M${usedCenter} 102 C${usedCenter} 121 208 116 208 137` : `M232 ${usedCenter} C305 ${usedCenter} 325 147 421 147`,
    unused: narrow ? `M${unusedCenter} 102 C${unusedCenter} 147 53 121 53 174 V191` : `M232 ${unusedCenter} C266 ${unusedCenter} 300 ${unusedCenter} 300 203 C300 244 250 244 214 244 H99`,
  };
}
